import { createApp } from 'vue'
import EventArchiveEmbeddedVideoMenu from '../components/event_archive_embedded_video_menu'
import dataPropsParser from '../data_props_parser'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName('vue_event_archive_video_menu')

  const iframeElement = document.querySelector('#js_event_archive_embedded_video iframe')
  if (!iframeElement) { return }

  Array.prototype.forEach.call(elements, element => {
    const dataProps = dataPropsParser(element.dataset.props)
    const assignDataiframeElement = { iframeElement, ...dataProps }

    const app = createApp(EventArchiveEmbeddedVideoMenu, assignDataiframeElement)
    app.mount(`#${element.id}`)
  })
})
